module.exports = __webpack_public_path__ + "static/media/add-to-calendar.77f6c799.svg";